<template>
  <div class="lv-img-list" :style="{ marginTop: marginTop + 'px' }" :class="{ borderTop }">
    <LvText v-if="title" h5 bold>{{ $t(title) }}</LvText>
    <div v-if="imageList.length" class="lv-img-list__content" :class="{ outline }">
      <LvImgPreviewBtn
        v-for="(imageItem, imageIndex) in imageList"
        :key="imageIndex"
        :small="small"
        :module="module"
        :medium="medium"
        :num="imageIndex"
        :id="imageItem.id"
        :url="imageItem.url"
        :name="imageItem.name"
        :hasScope="imageItem.hasScope"
        :isSystem="imageItem.isSystem"
        :showDeleteBtn="showDeleteBtn"
        :isLoading="imageItem.isLoading"
        :showMoreBtn="imageItem.showMoreBtn"
        :showDownloadBtn="imageItem.showDownloadBtn"
        :fileType="imageItem.fileType"
        class="ma-4"
        @go-to="$emit('go-to', $event)"
        @remove="$emit('delete-file', imageIndex)"
      />
    </div>
    <div v-else-if="noFileText" class="mt-20 ml-20">
      <LvText h4>{{ $t(noFileText) }}</LvText>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    imageList: {
      type: Array,
      default() {
        return [];
      },
    },
    outline: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 8,
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    noFileText: {
      type: String,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
    module: {
      type: String,
    },
  },
};
</script>
